export const dummyData = [
    {
        "id": 1,
        "title": "Ísadóra Nótt fer í tívolí",
        "image": "/static/images/tivoli.png",
        "price": 1750
    },
    {
        "id": 2,
        "title": "Ísadóra Nótt fer í skólaferðalag",
        "image": "/static/images/skolaferdalag.png",
        "price": 1750
    },
    {
        "id": 3,
        "title": "Ísadóra Nótt fer lendir í vandræðum",
        "image": "/static/images/vandraedi.png",
        "price": 1750
    },
    {
        "id": 4,
        "title": "Ísadóra Nótt fer á balletsýningu",
        "image": "/static/images/ballet.png",
        "price": 1750
    },
    {
        "id": 5,
        "title": "Ísadóra Nótt fer í útilegu",
        "image": "/static/images/utilega.png",
        "price": 1750
    },
    {
        "id": 6,
        "title": "Ísadóra Nótt á afmæli",
        "image": "/static/images/afmaeli.png",
        "price": 1750
    },
    {
        "id": 7,
        "title": "Ísadóra Nótt fer í skóla",
        "image": "/static/images/skoli.png",
        "price": 1750
    },
    {
        "id": 8,
        "title": "Ísadóra Nótt og töfrar vetrarins",
        "image": "/static/images/vetur.png",
        "price": 1750
    },
    {
        "id": 9,
        "title": "Ísadóra Nótt fer í gistipartí",
        "image": "/static/images/gisting.png",
        "price": 1750
    },
    {
        "id": 10,
        "title": "Mírabella gegnir ekki galdrabanni",
        "image": "/static/images/galdrabann.png",
        "price": 1750
    }
]

export const latestBook = {
    "id": 11,
    "title": "Ísadóra Nótt fer í frí",
    "image": "/static/images/fri.png",
    "price": 2750
}